// extracted by mini-css-extract-plugin
export default {"grid":"grid--AuFF4","span2":"span2--mgd4s","label":"label--T9zvf","noteContainer":"noteContainer--ON6JV"};